import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'qm-layer-loading-status',
  templateUrl: './layer-loading-status.component.html',
  styleUrls: ['./layer-loading-status.component.scss']
})
export class LayerLoadingStatusComponent implements OnInit {
  @Input() public isLoaded: boolean;
  @Input() public isLoaded$: Observable<boolean>;
  constructor() { }
    ngOnInit(): void {
  }

}
